import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-orders',
  templateUrl: './track-orders.component.html',
  styleUrls: ['./track-orders.component.css']
})
export class TrackOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
